export default __webpack_public_path__ + "static/media/send.41bf05b1.svg";